export default __webpack_public_path__ + "static/hiit_it_interval_timer_mac-move@4x-0e852d0bbf259ad310a7b3fb398ceb4e.webp";